import { ChatThreadRI } from 'common-utils/rest-interfaces';
import { Observable, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { AjaxResponse } from '../interfaces/AjaxResponse';
import { pdsHttpUtils } from '../pds-http-utils';

export class ChatThreadService {
  fetchParentParticipants(hostUrl: string, studentUid: string): Observable<Array<any>> {
    return pdsHttpUtils.get(hostUrl + `/navigation/v1/student/${studentUid}/parents`, {}, pdsHttpUtils.addUCAuthHeader({})).pipe(
      map((response: AjaxResponse) => {
        return JSON.parse(response.data).map((parent) => { return { userUid: parent.uid, userType: 'PARENT' }; });
      }));
  }

  fetchTopicThread(hostUrl: string, thread: any): Observable<ChatThreadRI> {
    let queryParams = {
      'topicUid': thread.topicUid!,
      'threadType': String(thread.threadType),
      'ownerUid': thread.ownerUid
    };
    return pdsHttpUtils.get(hostUrl + '/communication/v1/topic_thread', queryParams, pdsHttpUtils.addUCAuthHeader({})).pipe(
      mergeMap((response: AjaxResponse) => {
        if (response.status === 204) {
          return this.createTopicThread(hostUrl, thread);
        }
        return of(JSON.parse(response.data));
      }),
      catchError((err, sourceObs) => {
        if (err.status === 204) {
          return this.createTopicThread(hostUrl, thread);
        }
        return sourceObs;
      }));
  }

  private createTopicThread(hostUrl: string, thread: any): Observable<ChatThreadRI> {
    return pdsHttpUtils.post(hostUrl + '/communication/v1/thread', thread, {}, pdsHttpUtils.addUCAuthHeader({})).pipe(
      map((response: AjaxResponse) => {
        return JSON.parse(response.data);
      }));
  }
}
